export const columnasFilasHome = [
  {
    label: "#",
    field: "orden",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
    width: 90,
  },
  {
    label: "Nombre",
    field: "filaHomeName",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Descripción",
    field: "description",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Nombre (EN)",
    field: "filaHomeNameEng",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Descripción (EN)",
    field: "descriptionEng",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Fija",
    field: "estatico",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
    width: 90,
  },
  {
    label: "Disponibilidad Regional",
    field: "disponibilidadRegional",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "# Libros",
    field: "totalLibros",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
    width: 90,
  },
  {
    label: "Estado",
    field: "estado",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
    width: 130,
  },
  {
    label: "Acciones",
    field: "acciones",
    sort: "disabled",
    minimal: "lg",
    isVisible: true,
    width: 220,
  },
];

export const columnasLibrosFila = [
  {
    label: "Nombre Fila",
    field: "FilaHomeName",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Id Libro",
    field: "idLibro",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Nombre Libro",
    field: "title",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
  {
    label: "Acciones",
    field: "acciones",
    sort: "disabled",
    minimal: "lg",
    isVisible: true,
    width: 120,
  },
];

export const columnasPaquetesLibro = [
  {
    label: "Nombre Paquete",
    field: "packageName",
    sort: "asc",
    minimal: "lg",
    isVisible: true,
  },
];
